import { PRIMARY_NAV_HEIGHT } from '@/components/navigation/PrimaryNavigation';
import ModuleBuilder, { ModularPageProps, ModuleBuilderProps } from '@/modules/ModuleBuilder';
import { mediaBreakpointUp } from '@/styles/layout/utils';
import { remCalc } from '@/styles/typography/utils';
import { merge } from 'lodash';
import { FC, useMemo } from 'react';
import styled from 'styled-components';

interface ModularPageLayoutProps extends PropsWithClassName {
  props: ModularPageProps['modularPageProps'];
  config?: Partial<ModuleBuilderProps['config']>;
}

const ModularPageLayout: FC<ModularPageLayoutProps> = ({ props, className, config }) => {
  const mergedConfig = useMemo(
    () =>
      merge(
        {
          logoFarm: {
            awards: props.awards,
          },
        },
        config,
      ),
    [props, config],
  );

  if (!props.entry) return null;

  return (
    <PageWrapper className={className}>
      <ModuleBuilder props={props.entry.moduleBuilder} config={mergedConfig} />
    </PageWrapper>
  );
};

export default ModularPageLayout;

const PageWrapper = styled.section`
  padding-top: ${remCalc(PRIMARY_NAV_HEIGHT)};
  overflow-x: hidden; // Certain modules like the glow quote overflow on mobile

  > main > * + * {
    margin-top: 50px;
  }

  ${mediaBreakpointUp('desktop')} {
    > main > * + * {
      margin-top: 80px;
    }
  }

  ${mediaBreakpointUp('desktopWide')} {
    > main > * + * {
      margin-top: 120px;
    }
  }
`;
